export const HEADER_IDENTITY_ICON_SIZE = 20;

export const HEADER_CLOSE_ICON_SIZE = 18;

export const HEADER_SUBTITLE_TEST_ID = 'execution-detail-header-subtitle';
